// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import {
    VirtualAssistantChatEmptyStateContainer,
    VirtualAssistantChatEmptyStateTitle,
    VirtualAssistantChatEmptyStateDescription,
    // VirtualAssistantChatEmptyStateMessagesWrapper,
    // VirtualAssistantChatEmptyStateMessageLabel,
    VirtualAssistantChatEmptyStateTitleWrapper,
    VirtualAssistantChatEmptyStateMessageContainer,
    VirtualAssistantChatEmptyStateMessageLabel
} from "./VirtualAssistantChatEmptyState.styles";

// Types
import { VirtualAssistantChatEmptyStateProps, VirtualAssistantChatEmptyStateMessageProps } from "./VirtualAssistantChatEmptyState.types";

export const VirtualAssistantChatEmptyState: FunctionComponent<VirtualAssistantChatEmptyStateProps> = ({
    title,
    description
    // messageLabel,
    // messagesComposition
}) => {
    return (
        <VirtualAssistantChatEmptyStateContainer>
            <VirtualAssistantChatEmptyStateTitleWrapper>
                <VirtualAssistantChatEmptyStateTitle>{title}</VirtualAssistantChatEmptyStateTitle>

                <VirtualAssistantChatEmptyStateDescription>{description}</VirtualAssistantChatEmptyStateDescription>
            </VirtualAssistantChatEmptyStateTitleWrapper>

            {/* <VirtualAssistantChatEmptyStateMessagesWrapper>
                <VirtualAssistantChatEmptyStateMessageLabel>{messageLabel}</VirtualAssistantChatEmptyStateMessageLabel>

                {messagesComposition}
            </VirtualAssistantChatEmptyStateMessagesWrapper> */}
        </VirtualAssistantChatEmptyStateContainer>
    );
};

export const VirtualAssistantChatEmptyStateMessage: FunctionComponent<VirtualAssistantChatEmptyStateMessageProps> = ({ text, handleClick }) => {
    return (
        <VirtualAssistantChatEmptyStateMessageContainer onClick={handleClick}>
            <VirtualAssistantChatEmptyStateMessageLabel>{text}</VirtualAssistantChatEmptyStateMessageLabel>
        </VirtualAssistantChatEmptyStateMessageContainer>
    );
};
